import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

const labelCss = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
});

export const Label = ({ children }: PropsWithChildren) => {
    return <span css={labelCss}>{children}</span>;
};
